import { useEffect } from 'react';

// import from @services/index is causing cycled dependency
import IAPService, { PurchaseType } from '../services/IAPService';
import CrashlyticsService from '../services/CrashlyticsService';
import { useAsyncInit } from './useAsyncInit';

/**
 * Init IAPService and add purchaseUpdatedListener
 *
 * @param listener
 */
export function useInAppPurchase(
  listener?: (purchase: PurchaseType) => Promise<void> | void,
) {
  useAsyncInit(async () => {
    try {
      await IAPService.initConnection();
      await IAPService.flushFailedPurchasesCachedAsPendingAndroid();
      IAPService.addPurchaseUpdatedListener(async (purchase) => {
        await listener?.(purchase);
      });
    } catch (error) {
      CrashlyticsService.captureException(error);
    }
  });

  useEffect(() => {
    return () => {
      IAPService.removePurchaseUpdatedListener();
    };
  }, []);
}
